/* INVICTUS — overlay menu toggle + simple slider arrows */
(function () {
  'use strict';

  function openMenu(menu) {
    if (!menu) return;
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(menu) {
    if (!menu) return;
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function bindOverlay() {
    var menu = document.querySelector('[data-invictus-menu]');
    if (!menu) return;

    document.querySelectorAll('[data-invictus-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openMenu(menu);
      });
    });

    menu.querySelectorAll('[data-invictus-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu(menu);
      });
    });

    // Close on link click
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { closeMenu(menu); });
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu(menu);
    });

    // Close on backdrop click (clicking the menu wrapper itself, not children)
    menu.addEventListener('click', function (e) {
      if (e.target === menu) closeMenu(menu);
    });
  }

  function bindSliders() {
    document.querySelectorAll('[data-invictus-slider]').forEach(function (slider) {
      var track = slider.querySelector('.invictus-category__track');
      if (!track) return;

      var prev = slider.querySelector('[data-invictus-prev]');
      var next = slider.querySelector('[data-invictus-next]');

      function step() {
        var firstCard = track.firstElementChild;
        if (!firstCard) return 300;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });
  }

  /*
   * Shopify may briefly serve a cached product-page fragment after a live
   * section update. Upgrade the previous always-open arrival card at runtime
   * so direct, cache-warm product URLs receive the same collapsed disclosure.
   * The current <details> markup is left untouched.
   */
  function upgradeArrivalDisclosure() {
    var oldCard = document.querySelector('.iv-arrival');
    if (!oldCard || oldCard.tagName.toLowerCase() === 'details') return;

    var disclosure = document.createElement('details');
    disclosure.className = 'iv-arrival iv-arrival--runtime';

    var summary = document.createElement('summary');
    summary.className = 'iv-arrival__summary';
    summary.innerHTML = '<span class="iv-arrival__summary-copy"><small>STOCK &amp; DELIVERY</small><strong>現貨 / 預計到貨時間</strong></span><span class="iv-arrival__toggle" aria-hidden="true"></span>';

    var body = document.createElement('div');
    body.className = 'iv-arrival__body';
    body.innerHTML = '<h2 class="iv-arrival__title">關於預購與出貨</h2>';
    Array.prototype.forEach.call(oldCard.children, function (child) {
      if (child.classList.contains('iv-arrival__head')) return;
      body.appendChild(child);
    });

    disclosure.appendChild(summary);
    disclosure.appendChild(body);
    oldCard.replaceWith(disclosure);

    if (!document.getElementById('iv-arrival-runtime-style')) {
      var style = document.createElement('style');
      style.id = 'iv-arrival-runtime-style';
      style.textContent =
        '.invictus-product .iv-arrival--runtime{padding:0!important;position:relative;overflow:hidden;margin:0 0 22px;border:1px solid var(--iv-line);border-left:3px solid var(--iv-blood);background:linear-gradient(135deg,rgba(215,38,61,.09),rgba(22,22,25,.86) 38%,rgba(15,15,17,.98));color:#bbb9b3}' +
        '.invictus-product .iv-arrival--runtime::after{display:none!important}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__summary{cursor:pointer;list-style:none;min-height:58px;padding:13px 16px;display:flex;justify-content:space-between;align-items:center;gap:16px}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__summary::-webkit-details-marker{display:none}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__summary-copy{display:flex;flex-direction:column;gap:3px}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__summary-copy small{color:var(--iv-blood);font-family:Menlo,Consolas,monospace;font-size:8.5px;line-height:1.4;font-weight:700;letter-spacing:.18em}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__summary-copy strong{color:var(--iv-bone);font-size:12px;line-height:1.4;font-weight:600;letter-spacing:.12em}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__toggle{color:var(--iv-blood);font-family:Menlo,Consolas,monospace;font-size:9px;letter-spacing:.08em;white-space:nowrap}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__toggle::before{content:"展開  ▾"}' +
        '.invictus-product .iv-arrival--runtime[open] .iv-arrival__toggle::before{content:"收合  ▴"}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__body{padding:4px 16px 17px;border-top:1px solid var(--iv-line)}' +
        '.invictus-product .iv-arrival--runtime .iv-arrival__title{margin:14px 0 12px;color:var(--iv-bone);font-size:14px;line-height:1.4;font-weight:700;letter-spacing:.06em}' +
        '@media(max-width:849px){.invictus-product .iv-arrival--runtime .iv-arrival__summary{min-height:54px;padding:11px 13px}.invictus-product .iv-arrival--runtime .iv-arrival__summary-copy strong{font-size:11.5px;letter-spacing:.09em}.invictus-product .iv-arrival--runtime .iv-arrival__body{padding:3px 13px 15px}}';
      document.head.appendChild(style);
    }
  }

  function init() {
    bindOverlay();
    bindSliders();
    upgradeArrivalDisclosure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
